"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatting_1 = require("./utils/formatting");
/**
 * Returns the number with a suffix of %
 */
exports.percent = formatting_1.formatUnit('%');
/**
 * Returns the number with a suffix of deg
 */
exports.deg = formatting_1.formatUnit('deg');
/**
 * Returns the number with a suffix of em
 */
exports.em = formatting_1.formatUnit('em');
/**
 * Returns the number with a suffix of ex
 */
exports.ex = formatting_1.formatUnit('ex');
/**
 * Returns the number with a suffix of px
 */
exports.px = formatting_1.formatUnit('px');
/**
 * Returns the number with a suffix of rad
 */
exports.rad = formatting_1.formatUnit('rad');
/**
 * Returns the number with a suffix of rem
 */
exports.rem = formatting_1.formatUnit('rem');
/**
 * Returns the number with a suffix of vh
 */
exports.viewHeight = formatting_1.formatUnit('vh');
/**
 * Returns the number with a suffix of vw
 */
exports.viewWidth = formatting_1.formatUnit('vw');
/**
 * Returns the number with a suffix of turn
 */
exports.turn = formatting_1.formatUnit('turn');
